import { StarGroup } from '@/assets/icons/star-group'
import { StepLoadingIcon } from '@/assets/icons/step-loading-icon'
import { AnimatePresence, motion } from 'framer-motion'
import type { JSX } from 'react'

interface TransferLoadingProps {
  loadingLabel: string
  image?: JSX.Element
}

export const TransferLoading = ({ loadingLabel, image }: TransferLoadingProps) => {
  return (
    <div className="flex justify-center items-center flex-col gap-3">
      {!image && <StepLoadingIcon />}
      {image}
      <div>
        <AnimatePresence mode="wait">
          <motion.div
            key={loadingLabel} // importante para o AnimatePresence detectar troca
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 20,
              mass: 0.5
            }}
            className="block"
          >
            <div className='flex gap-1'>
              <StarGroup />
              {loadingLabel}
              <StarGroup />
            </div>
          </motion.div>
        </AnimatePresence>
        {/* <p>{loadingLabel}</p> */}
      </div>
    </div>
  )
}
